import {
  IEventTableExportParams,
  useAddEventTablesExportJobMutation
} from 'app/services/api/datamanagement/eventTableAttributes'
import { useExportJobContext } from 'common/contexts/useExportJobContext'

interface IDataExportButton {
  exportParams: IEventTableExportParams
}

const DataExportButton = ({ exportParams }: IDataExportButton) => {
  const [addEventTablesExportJob] = useAddEventTablesExportJobMutation()
  const { exportJob, isExporting, createDataExportJob } = useExportJobContext()

  return (
    <button
      className={[
        'mt-6 px-8 py-3',
        'rounded bg-lighthouseBlue',
        'text-white',
        'disabled:opacity-30'
      ].join(' ')}
      onClick={() => createDataExportJob(addEventTablesExportJob, exportParams)}
      disabled={
        isExporting ||
        exportJob.isFetching ||
        exportParams.eventTableList.length < 1
      }
    >
      <span className='uppercase'>Export Data</span>
    </button>
  )
}

export default DataExportButton
